import {
  DataStoreModel,
  ModelTypes,
} from '../../dataStorePersistence/DataStoreModel';

export enum ConneqtStatus {
  Created = 'CREATED',
  AccountNotFound = 'ACCOUNT_NOT_FOUND',
  // TODO: allow user to send
  // TODO: existing player they already have or by creating a new player.
  // TODO: once conneqt request doesn't have status set to CREATED the user can no longer change email. They have to DISCONNEQTED and create a new one.
  // TODO: once disconneqted the user cannot change the conneqt instance until it is set to CONNEQTED
  SentInvite = 'SEND_INVITE',
  SentInviteFailed = 'SEND_INVITE_FAILED',
  INVITE_SENT = 'INVITE_SENT',
  // TODO: if account is not found then email to user to signup an account. When they sign up ACCOUNT_NOT_FOUND should change to PENDING.
  Pending = 'PENDING',
  Conneqted = 'CONNEQTED',
  Disconneqted = 'DISCONNEQTED',
  REJECTED = 'REJECTED',
  ClinicAppointmentBooked = 'CLINIC_APPOINTMENT_BOOKED',
}

// TODO: create different types to communicate payloads for createClinic, createOrg, createGuardian rather than using Conneqt type and making everything optional. Maybe frontend vs backend model can be useful as well if you can have a different type before it has been processed backend.

// export interface Assessment extends DataStoreModel<ModelTypes.Assessment> {
export interface Conneqt extends DataStoreModel {
  readonly modelType: ModelTypes.Conneqt;
  readonly accountId: string;
  readonly accountName: string;
  readonly requestAccountType: string;
  readonly requestAccountEmail: string;
  readonly requestUserId: string;
  readonly requestUserEmail: string;
  readonly requestPlayerId: string;
  readonly requestPlayerClues?: string;
  readonly status: ConneqtStatus;
  readonly responseAccountId?: string;
  readonly responseAccountType?: string;
  readonly responseAccountName?: string;
  readonly responsePlayerId?: string;
  readonly responsePlayerClues?: string;
  readonly responseEmail?: string;
  readonly approvedUserFullName?: string;
  readonly approvedUserId?: string;
  readonly approvedAt?: string;
  readonly disconnectedAccountId?: string;
  readonly disconnectedAccountName?: string;
  readonly disconnectedAt?: string;
  readonly disconnectedUserFullName?: string;
  readonly disconnectedUserId?: string;
}

export interface ConneqtBackend extends DataStoreModel {
  readonly modelType: ModelTypes.Conneqt;
  readonly accountId: string;
  readonly accountName: string;
  readonly requestAccountType: string;
  readonly requestAccountEmail: string;
  readonly requestUserId: string;
  readonly requestUserEmail: string;
  readonly requestPlayerId: string;
  readonly requestPlayerClues?: string;
  readonly status: ConneqtStatus;
  readonly responseAccountId?: string;
  readonly responseAccountType?: string;
  readonly responseAccountName?: string;
  readonly responsePlayerId?: string;
  readonly responsePlayerClues?: string;
  readonly responseEmail?: string;
  readonly approvedUserFullName?: string;
  readonly approvedUserId?: string;
  readonly approvedAt?: string;
  readonly disconnectedAccountId?: string;
  readonly disconnectedAccountName?: string;
  readonly disconnectedAt?: string;
  readonly disconnectedUserFullName?: string;
  readonly disconnectedUserId?: string;
  // readonly _deleted?: boolean;
}

export interface CreateConneqtPayload {
  requestPlayerId: string;
  requestPlayerClues: string | undefined;
  responseEmail?: string;
  responseAccountId?: string;
  disconnectedAccountId?: string;
}

export interface ViewConneqtPayload {
  id: string;
  responseEmail: string;
  accountId: string;
  requestPlayerClues?: string | undefined;
  requestPlayerPhone?: string | undefined;
  responsePlayerClues?: string | undefined;
  status: ConneqtStatus;
  requestPlayerId: string;
  responsePlayerId: string;
  responseAccountName?: string;
  requestUserEmail: string;
  accountName: string;
  disconnectedAccountId?: string;
}
